const Industries = () => {
  return <h2>Industries</h2>;
};

export default Industries;
